<div (click)="onExpandedChanged()" class="filter-heading">
  <h4 class="heading">
    {{ headingText }}
    <span
      *ngIf="shouldDisplaySelectedOptionsCount"
      class="selected-options-count"
      [matBadge]="selectedOptionsCount"
      matBadgeColor="primary"
      matBadgeOverlap="false"></span>
  </h4>
  <div
    class="icon-functional icon-down-toggle"
    [class.expanded]="isExpanded"></div>
</div>
